<div class="page-content">
    <p-panel header="S3 Buckets management" class="no-x-padding">
        <app-s3-bucket-crud></app-s3-bucket-crud>
    </p-panel>
</div>
